import { ITheme } from "../../utils/theme"

export const selectStyle = {
  margin: { xs: 0.5, lg: 1 },
  width: '100%',
  "&.MuiOutlinedInput-root": {
    "& .MuiSelect-select": {
      whiteSpace: { xs: "pre-wrap", sm: "nowrap" },
      padding: { xs: "5px 10px", lg: "16.5px 14px" },
      display: "flex",
      fontSize: { xs: '.85rem', lg: '16px' }
    }
  }
}

export const lastUpdateCaptionStyle = {
  color: (theme: ITheme) => theme.palette.blue[600],
  textAlign: 'center',
  pl: 1,
  mb: { xs: 0.5, sm: 2 },
}

export const contentStyle = {
  textAlign: 'center',
}

export const asteriskStyle = {
  color: (theme: ITheme) => theme.palette.red.A700
}

export const containerFixedStyle = {
  position: 'fixed',
  top: '63px',
  left: 0,
  ml: 0,
  background: 'white',
  zIndex: 1,
  justifyContent: 'center',
  width: '100%'
}

export const containerStyle = {
  mb: { xs: .5, sm: 2 },
  '& >.MuiGrid-item': { pt: { xs: 1, sm: 2 } }
}

export const dropdownStyle = {
  justifyContent: 'center',
}